enum EntityTypeEnum {
  Advert = 'advert',
  CarouselItem = 'carousel-item'
}

export default EntityTypeEnum;
